<div fxLayout="column" fxLayoutAlign="start start" class="layout margin full-width">
  <pre>{{getJson() | json}}</pre>
</div>